export class UpdateOrderMessage {  
  buildTypeId: number
  cartridgeId?: number
  customerSuppliedParts: string
  onHold: boolean
  partsDiscountPercentage: number
  scheduledDate?: string
  servicesDiscountPercentage: number

  constructor(buildTypeId: number, cartridgeId: number|undefined, customerSuppliedParts: string, onHold: boolean, partsDiscountPercentage: number, scheduledDate: string|undefined, servicesDiscountPercentage: number) {
    this.buildTypeId = buildTypeId
    this.cartridgeId = cartridgeId
    this.customerSuppliedParts = customerSuppliedParts
    this.onHold = onHold
    this.partsDiscountPercentage = partsDiscountPercentage
    this.scheduledDate = scheduledDate
    this.servicesDiscountPercentage = servicesDiscountPercentage
  }
}
  